import React from 'react';
import {
  DialogTitle,
  DialogContent,
  LinearProgress,
  Typography,
  List,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { Add as AddIcon } from '@material-ui/icons';
import moment from 'moment';

import Dialog from '../Dialog';
import AddCourseRecordDialog from '../../containers/AddCourseRecordDialog';
import { addCourseRecordDialogOpenSource } from '../../constants';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  multilineTextBox: {
    marginTop: 20
  },
  floatRight: {
    float: 'right'
  },
  addIcon: {
    marginTop: 6
  },
  singleCourseContainer: {
    padding: theme.spacing(1)
  },
  courseName: {
    fontSize: 18,
    fontWeight: 800,
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(3),
    display: 'inline'
  },
  expiry: {
    paddingTop: theme.spacing(1),
    display: 'inline'
  },
  expired: {
    paddingTop: theme.spacing(1),
    color: theme.palette.danger.main,
    display: 'inline'
  }
}));

const SingleCourse = (props) => {
  const { course } = props;
  const classes = useStyles();
  const isValidExpiry = moment(course.nextCourseDate).isAfter(
    moment.utc('0001-01-01')
  );
  const isExpired = moment().isAfter(course.nextCourseDate) && isValidExpiry;

  return (
    <div className={classes.singleCourseContainer}>
      <Typography variant="h3" className={classes.courseName}>
        {course.unitDescription}
      </Typography>
      <Typography
        variant="subtitle1"
        className={isExpired ? classes.expired : classes.expiry}
      >
        {`${isExpired ? 'Expired' : 'Expiry date'} - ${
          isValidExpiry
            ? course && moment(course.nextCourseDate).format('DD/MM/YYYY')
            : 'none'
        }`}
      </Typography>
    </div>
  );
};

const CoursesForPersonnelDialog = (props) => {
  const {
    openDialog,
    personnel,
    onOpenCoursesForPersonnelDialog,
    getCoursesForPersonnel,
    courses,
    isLoading,
    onOpenAddCourseRecordDialog,
    openAddCourseRecordDialog
  } = props;
  const classes = useStyles();

  React.useEffect(
    () => {
      if (personnel) {
        getCoursesForPersonnel(personnel.id);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [personnel]
  );

  const onDialogClose = () => {
    onOpenCoursesForPersonnelDialog(false);
  };

  const handleAddTrainingRecordClick = (personnel) => {
    var source =
      addCourseRecordDialogOpenSource.FROM_COURSES_FOR_PERSONNEL_DIALOG;

    onOpenAddCourseRecordDialog(true, personnel.id, source);
  };

  //Sorting courses
  courses.sort((a, b) => {
    return new Date(b.nextCourseDate) - new Date(a.nextCourseDate);
  });

  return (
    <React.Fragment>
      {openAddCourseRecordDialog ? <AddCourseRecordDialog /> : null}

      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isLoading ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {personnel && `${personnel.firstName} ${personnel.lastName}`}

          <IconButton
            color="primary"
            component="span"
            className={classes.floatRight}
            onClick={onDialogClose}
          >
            <CloseIcon />
          </IconButton>
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            className={`${classes.floatRight} ${classes.addIcon}`}
            onClick={() => handleAddTrainingRecordClick({ ...personnel })}
          >
            Add
          </Button>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <List dense={true}>
            {courses &&
              courses.map((course) => {
                return <SingleCourse course={course} key={course.id} />;
              })}
          </List>{' '}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default CoursesForPersonnelDialog;
